import {
	adminClient,
	emailOTPClient,
	organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

function trimTrailingSlash(url: string) {
	return url.endsWith("/") ? url.slice(0, -1) : url;
}

function resolveBrowserOrigin() {
	if (typeof globalThis === "undefined" || !("location" in globalThis)) {
		return null;
	}

	const { origin } = globalThis.location;
	if (!origin || origin === "null") {
		return null;
	}

	return origin;
}

const configuredBaseUrl =
	process.env.BETTER_AUTH_URL ??
	process.env.VITE_PUBLIC_SERVER ??
	resolveBrowserOrigin();
const defaultBaseUrl = "http://localhost:3000";

const baseURL = configuredBaseUrl
	? `${trimTrailingSlash(configuredBaseUrl)}/api/auth`
	: `${defaultBaseUrl}/api/auth`;

export const authClient = createAuthClient({
	baseURL,
	plugins: [organizationClient(), adminClient(), emailOTPClient()],
});
